export const CURRENCY_ARRAY_FOR_EURO_OR_USD = [5, 10, 20, 50, 100];
export const CURRENCY_ARRAY_FOR_ILS = [10, 20, 50, 100, 200];
export const DEFAULT_CURRENCY_FOR_EURO_OR_USD = 10;
export const DEFAULT_CURRENCY_FOR_ILS = 20;
export const MIN_CURRENCY_VALUE_FOR_ALL = 0;
export const TRANSACTION_PURCHASE_TYPE = "thankyoupayment";
export const DEFAULT_COUNTRY_ID = 0;

export const DEFAULT_NUMBER = "1";
export const DEFAULT_PASSWORD = "1";

